import { useContext, useEffect, useState } from "react";
import useLocalStorage from "../../Utility/useLocalStorage";
import Repo from "../../Utility/Repo";
import { Link } from "react-router-dom";
import { TokenContext } from "../../Components/TokenContext";
import CardHome from "../../Components/CardHome";

const cards = [
  {
    id: 1,
    titolo: "INTERVENTI",
    descrizione:
      "Potrai visualizzare tutti gli interventi disponibili, inserirne nuovi e filtrarli per categoria",
    badge: 0,
    link: "/lista_interventi",
  },
  {
    id: 2,
    titolo: "UTENTI",
    descrizione:
      "Potrai visualizzare tutti gli utenti presenti nella  piattaforma, inserirne nuovi e caricare per loro l'Isee",
    badge: 0,
    link: "/lista_utenti",
  },
  {
    id: 3,
    titolo: "ISCRIZIONI",
    descrizione:
      "Potrai visualizzare tutte le iscrizioni nuove e visualizzarne i dettagli",
    badge: 0,
    link: "/iscrizioni",
  },
  {
    id: 4,
    titolo: "CATEGORIE",
    descrizione:
      "Potrai visualizzare tutti i servizi disponibili, inserirne nuovi o eliminarli",
    badge: 0,
    link: "/categorie",
  },
  /*{
    id: 5,
    titolo: "AGGIORNAMENTI MASSIVI",
    descrizione:
      "Aggiorna in blocco i dati anagrafici e l'ISEE dei cittadini tramite ANPR e INPS",
    badge: 0,
    link: "/aggiornamento_massivo",
  },*/
  {
    id: 5,
    titolo: "CALENDARIO",
    descrizione:
      "Potrai registrare e consultare le presenze degli alunni, filtrare per classe e gestire le versioni degli elenchi",
    badge: 0,
    link: "/calendario",
    last: true,
  },
];

function Home(props) {
  const [ISEEList, setISEEList] = useState();
  const [countNewSubscriprionCount, setcountNewSubscriprionCount] = useState();
  const [cardsState, setCardsState] = useState([]);
  const apiToken = useContext(TokenContext);
  const [loadedUser, setLoadedUser] = useState();
  //
  //setCardsState(cards);

  useEffect(() => {
    Repo.getIseeListUploaded(apiToken)
      .then((response) => {
        setISEEList(response.data.length > 0 && response.data.length);
        let el = cards.map((item) => {
          if (item.id === 1) {
            item.badge = response.data.length;
          }
          return;
          item;
        });

        // Set the previous list to the new list
        setCardsState(el);
      })
      .catch((error) => {
        console.log(error);
      });

    Repo.getUsersLoadedCount(apiToken)
      .then((response) => {
        setLoadedUser(parseInt(response.data));
        if (parseInt(response.data) > 0) {
          let e2 = cards.map((item) => {
            if (item.id === 2) {
              ((item.badge = parseInt(response.data)),
                (item.link = "/lista_utenti?loaded=true"));
            }
            return;
            item;
          });

          setCardsState(e2);
        }
      })
      .catch((error) => {
        console.log(error);
      });

    //chiamata repo per indicare quante iscrizioni nuove ci sono
    Repo.getSubscriptionNewCount(apiToken)
      .then((response) => {
        setcountNewSubscriprionCount(parseInt(response.data));
        if (parseInt(response.data) > 0) {
          let e3 = cards.map((item) => {
            if (item.id === 3) {
              ((item.badge = parseInt(response.data)),
                (item.link = "/iscrizioni?loaded=true"));
            }
            return;
          });
          setCardsState(e3);
        }
      })
      .catch((error) => {
        console.log(error);
      });

    Repo.getRefoundReceiptNewList(apiToken)
      .then((response) => {
        let e6 = cards.map((item) => {
          if (item.id === 4) {
            item.badge = parseInt(response.data.length);
          }
          return;
        });

        // Set the previous list to the new list
        setCardsState(e6);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  return (
    <>
      <h1>PANNELLO OPERATORE</h1>
      <div className="clearfix col-lg-8 py-lg-2">
        <p>
          Riepilogo delle principali funzioni di{" "}
          <strong>Semplícita Ambiti Territoriali Sociali</strong>
        </p>
      </div>
      <div className="row">{cards.map(CardHome)}</div>
    </>
  );
}

export default Home;
